<div class="generales">
  <div fxLayout="row" fxLayoutAlign="center stretch" >
  <mat-spinner class="cargando" *ngIf="cargando"></mat-spinner>
  </div>

  <div *ngIf="!cargando">
  <h1 class="titutlo">{{'SECCIONES.AT_RESPUESTAS_ENCUESTA.TITULO' | translate}}</h1>

<div fxLayout="column" fxLayoutAlign="center center" >

<!-- <img class="logoCliente" src="assets/images/norm35/resuTest/DEMO_ENCUESTA.jpg" alt=""> -->
<!-- TITULOS -->
  <table mat-table  class="mat-elevation-z8">
    <ng-container matColumnDef="seccionPregunta">
      <!-- <th mat-header-cell *matHeaderCellDef id="respuestas" style="width: 75%;"> Sección / Pregunta </th> -->
      <th mat-header-cell *matHeaderCellDef id="respuestas" style="width: 75%;"> {{'SECCIONES.AT_RESPUESTAS_ENCUESTA.PREGUNTA' | translate}} </th>
    </ng-container>

    <ng-container matColumnDef="texto">
      <th mat-header-cell *matHeaderCellDef id="respuestas"> {{'SECCIONES.AT_RESPUESTAS_ENCUESTA.RESPUESTA' | translate}} </th>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
  </table>

<!-- TABLA SECCION 1 -->
<table mat-table [dataSource]="tablaRespuestas" class="mat-elevation-z8">
  <ng-container matColumnDef="seccionPregunta">
    <!-- <th mat-header-cell *matHeaderCellDef> I.- Acontecimiento traumático severo </th> -->
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" style="width: 80%;"> {{element.StatementName}} </td>
  </ng-container>

  <ng-container matColumnDef="si">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> {{'SECCIONES.AT_RESPUESTAS_ENCUESTA.SI' | translate}} </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.ResponseValueYES}} </td>
  </ng-container>

  <ng-container matColumnDef="no">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> {{'SECCIONES.AT_RESPUESTAS_ENCUESTA.NO' | translate}} </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.ResponseValueNO}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table> <br> <br>

<!-- TABLA SECCION 2 -->
<!-- <table mat-table [dataSource]="dataSource2" class="mat-elevation-z8">

  <ng-container matColumnDef="seccionPregunta">
    <th mat-header-cell *matHeaderCellDef> II.- Recuerdos persistentes sobre el acontecimiento (durante el último mes) </th>
    <td mat-cell *matCellDef="let element" style="width: 80%;"> {{element.seccionPregunta}} </td>
  </ng-container>

  <ng-container matColumnDef="si">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> Si </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.si}} </td>
  </ng-container>

  <ng-container matColumnDef="no">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> No </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.no}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table> <br> <br> -->

<!-- TABLA SECCION 3 -->
<!-- <table mat-table [dataSource]="dataSource3" class="mat-elevation-z8">

  <ng-container matColumnDef="seccionPregunta">
    <th mat-header-cell *matHeaderCellDef> III.- Esfuerzo por evitar circunstancias parecidas o asociadas al acontecimiento (durante el último mes) </th>
    <td mat-cell *matCellDef="let element" style="width: 80%;"> {{element.seccionPregunta}} </td>
  </ng-container>

  <ng-container matColumnDef="si">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> Si </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.si}} </td>
  </ng-container>

  <ng-container matColumnDef="no">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> No </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.no}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table> <br> <br> -->

<!-- TABLA SECCION 4 -->
<!-- <table mat-table [dataSource]="dataSource4" class="mat-elevation-z8">

  <ng-container matColumnDef="seccionPregunta">
    <th mat-header-cell *matHeaderCellDef> IV.- Afectación (durante el último mes) </th>
    <td mat-cell *matCellDef="let element" style="width: 80%;"> {{element.seccionPregunta}} </td>
  </ng-container>

  <ng-container matColumnDef="si">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> Si </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.si}} </td>
  </ng-container>

  <ng-container matColumnDef="no">
    <th mat-header-cell *matHeaderCellDef id="respuestas"> No </th>
    <td mat-cell *matCellDef="let element" id="respuestas"> {{element.no}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table> -->

</div>
</div>
  </div>
